import React, { JSX } from 'react';
import {
  withDatasourceCheck,
  Text as JssText,
  RichText as JssRichText,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { TitleDescriptionSectionsProps } from '@greystar/ui/src/component-props';

const TitleDescriptionSections = (props: TitleDescriptionSectionsProps): JSX.Element => {
  const sections = props.fields?.data?.datasource?.children?.results || [];

  return (
    <div className="title-description-sections">
      {sections.map((section) => (
        <div key={section.id} className="section">
          {section.sectionTitle.value && (
            <h2 className="section-title">
              <JssText field={section.sectionTitle} />
            </h2>
          )}
          {section.sectionDescription.value && (
            <div className="section-description">
              <JssRichText field={section.sectionDescription} />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default withDatasourceCheck()<TitleDescriptionSectionsProps>(TitleDescriptionSections);
